import { Message } from 'element-ui'

import axios from "axios"
import store from '@/store/index.js'
import router from "@/router/index.js"

const request = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 60000
});

// 请求拦截器
request.interceptors.request.use(
    function (config) {
        let adminAccessToken = store.state.adminUser.accessToken;
        if (adminAccessToken != null && adminAccessToken != '') {
            config.headers['Authorization'] = "Bearer " + adminAccessToken
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// 响应拦截器
request.interceptors.response.use(
    function (response) {
        let result = response.data;
        if (result.succeeded) {
            return result;
        }
        else {
            if (result.statusCode == 401 || result.statusCode == 403) {
                router.push({ path: "/admin/login" }).catch(() => { });
            }
            else {
                Message({
                    type: "error",
                    message: result.errors,
                    showClose: true,
                    duration: 5 * 1000
                });
                return Promise.reject(result.errors);
            }
        }
    },
    function (error) {
        Message({
            type: "error",
            message: error,
            showClose: true,
            duration: 5 * 1000
        });
        return Promise.reject(error);
    }
);

export default request;